export default "__VITE_ASSET__DD1JAP4___"